import React from 'react'
import AccountMenuLoyaltyNoAccountBronzeTile from './AccountMenuLoyaltyNoAccountBronzeTile'
import AccountMenuLoyaltyNoAccountSilverTile from './AccountMenuLoyaltyNoAccountSilverTile'
import AccountMenuLoyaltyNoAccountGoldTile from './AccountMenuLoyaltyNoAccountGoldTile'

interface Props {
  eligibilityTier: App.LoyaltyTier
  onLinkClick: () => void
}

function AccountMenuLoyaltyNoAccountDetailsTiles(props: Props) {
  const { eligibilityTier, onLinkClick } = props
  return (<>
    {eligibilityTier === 'bronze' &&
      <AccountMenuLoyaltyNoAccountBronzeTile
        onLinkClick={onLinkClick}
      />
    }
    {eligibilityTier === 'silver' &&
      <AccountMenuLoyaltyNoAccountSilverTile
        onLinkClick={onLinkClick}
      />
    }
    {eligibilityTier === 'gold' &&
      <AccountMenuLoyaltyNoAccountGoldTile
        onLinkClick={onLinkClick}
      />
    }
  </>)
}

export default AccountMenuLoyaltyNoAccountDetailsTiles
